import { render, staticRenderFns } from "./WEBLISTCHOOSER.vue?vue&type=template&id=61dc51c3"
import script from "./WEBLISTCHOOSER.vue?vue&type=script&lang=js"
export * from "./WEBLISTCHOOSER.vue?vue&type=script&lang=js"
import style0 from "./WEBLISTCHOOSER.vue?vue&type=style&index=0&id=61dc51c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports